function getEnumDescription(value) {
  switch (value){
    case 1: return "План";
    case 2: return "Факт";
    default: return "";
  }
}

function getStatuses(){
  return [
    { value: PLAN, label: "План" },
    { value: FACT, label: "Факт" },
  ];
}

var PLAN = 1;
var FACT = 2;

export {
  PLAN,
  FACT,
  getEnumDescription,
  getStatuses,
};